import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fillRule="nonzero" d="M5.125 7L4 8.006 12 17l8-8.994L18.875 7l-6.863 7.743z" /></svg>);